module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7a3d188d587d856da4a6914fcfe82f65.png";